// parseDate('06.21.2010', 'mm.dd.yyyy');
// parseDate('21.06.2010', 'dd.mm.yyyy');
// parseDate('2010/06/21', 'yyyy/mm/dd');
// parseDate('2010-06-21');

export function parseDate(input, format) {
  format = format || "yyyy-mm-dd"; // default format
  var parts = input.match(/(\d+)/g),
    i = 0,
    fmt = {};
  // extract date-part indexes from the format
  format.replace(/(yyyy|dd|mm)/g, function (part) {
    fmt[part] = i++;
  });

  return new Date(parts[fmt["yyyy"]], parts[fmt["mm"]] - 1, parts[fmt["dd"]]);
}

export const convertDate = (dateString) => {
  const dateArray = dateString.split(" ");

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  let day = dateArray[0];
  let month = months.indexOf(dateArray[1]) + 1;
  let year = dateArray[2];

  return `${day}/${month}/${year}`;
};


export const FormatDate = (date) => {
  if (!(date instanceof Date)) return '';

  // Convert date to local timezone
  const localTimeOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };
  const dateInLocalTimezone = date.toLocaleDateString('en-GB', localTimeOptions);

  return dateInLocalTimezone;
};

export const generateDatesBetween = (startDate, endDate) => {
  const parseDate = (dateString) => {
    const [day, month, year] = dateString.split('/').map(Number);
    return { day, month, year };
  };

  const formatDate = ({ day, month, year }) => {
    return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
  };

  const isLeapYear = (year) => {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  };

  const getDaysInMonth = (month, year) => {
    const daysInMonth = [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return daysInMonth[month - 1];
  };

  const incrementDate = ({ day, month, year }) => {
    day += 1;
    if (day > getDaysInMonth(month, year)) {
      day = 1;
      month += 1;
      if (month > 12) {
        month = 1;
        year += 1;
      }
    }
    return { day, month, year };
  };

  const start = parseDate(startDate);
  const end = parseDate(endDate);
  const dates = [];

  let currentDate = start;
  while (
    currentDate.year < end.year ||
    (currentDate.year === end.year && currentDate.month < end.month) ||
    (currentDate.year === end.year && currentDate.month === end.month && currentDate.day <= end.day)
  ) {
    dates.push(formatDate(currentDate));
    currentDate = incrementDate(currentDate);
  }

  return dates;
};

export const GetDay = (dateString) => {
  if (typeof dateString !== 'string') {
    return "Invalid Date";
  }

  // Parse the input date string in the format "DD/MM/YYYY"
  const [day, month, year] = dateString.split('/');
  const parsedDate = new Date(`${month}/${day}/${year}`);

  if (Object.prototype.toString.call(parsedDate) === "[object Date]") {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const dayIndex = parsedDate.getDay();
    const day = days[dayIndex];
    return day;
  } else {
    return "Invalid Date";
  }
};

export function numberWithCommas(x) {
  x = parseInt(Math.round(x));

  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
